<template>
  <div class="laskuri-container text-left">
    <div class="row mb-3">
      <div class="col-md-12">
        <h2>Lisää oma tuote vertailuun</h2>
        <!-- <p>Vertaile muita tuotteita syöttämällä arvot:</p> -->
      </div>
      <div class="col-md-6 laskuri-column">
        <div class="narrow-input-wrapper-left">
          <label for="text">Nopea neutralointikyky</label>
          <input
            v-model="nnk"
            type="number"
            class="form-control"
            placeholder=""
            @input="calculateOtherAmount()"
          />
        </div>
      </div>
      <div class="col-md-6 laskuri-column">
        <div class="narrow-input-wrapper-left">
          <label for="text">Kosteus %</label>
          <input
            v-model="kosteus"
            type="number"
            class="form-control"
            placeholder=""
            @input="calculateOtherAmount()"
          />
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 laskuri-column show-button">
        <button
          :disabled="amount == null"
          class="btn btn-primary no-arrow add-own plausible-event-name=Kalkit+vertailu"
          @click="addOwnProduct"
        >
          Laske
        </button>
      </div>
    </div>

    <div v-if="showProduct" class="mt-4">
      <div class="row mb-3 small-title">
        <div class="col-6 other-result">
          <div>tuote</div>
        </div>
        <div class="col-3 other-result">
          <div>tarvittava käyttömäärä</div>
        </div>
        <div class="col-3 other-result">
          <div>kokonais&shy;tarve</div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-6">Vertailutuote</div>
        <div class="col-3">
          {{ amount }} <span class="small-title">t/ha</span>
        </div>
        <div class="col-3">
          {{ Math.ceil(amount * selectedAmounts.area) }}
          <span class="small-title">t</span>
        </div>
      </div>

      <div class="row mb-3" v-for="product in getSortedProducts" :key="product">
        <div class="col-6">
          {{ getKalkkilaskuriProducts[product].title.rendered }}
        </div>
        <div class="col-3">
          {{ solveAmount(getKalkkilaskuriProducts[product]) }}
          <span class="small-title">t/ha</span>
        </div>
        <div class="col-3">
          {{
            Math.ceil(
              solveAmount(getKalkkilaskuriProducts[product]) *
                selectedAmounts.area
            )
          }}
          <span class="small-title">t</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint  no-undef: 0 */
import { mapGetters, mapState } from "vuex";

export default {
  name: "OtherProduct",
  computed: {
    ...mapGetters([
      "getMaalaji",
      "getPhDelta",
      "getKalkkilaskuriProducts",
      "getSortedProducts",
    ]),
    ...mapState(["selectedAmounts"]),
  },
  methods: {
    addOwnProduct: function () {
      this.showProduct = true;
      if (this.firstClick) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kalkit_compare_trigger",
          form_id: "kalkkilaskuri",
        });
        this.firstClick = false;
      }
    },
    solveAmount: function (product) {
      const kosteus = parseFloat(product.acf.kosteus.replace(",", "."));
      const nnk = parseFloat(
        product.acf.nopeavaikutteinen_neurtalointikyky.replace(",", ".")
      );
      return this.calculateAmount(kosteus, nnk);
    },
    calculateOtherAmount: function () {
      if (this.kosteus >= 0 && this.nnk > 0) {
        this.amount = this.calculateAmount(this.kosteus, this.nnk);
      } else {
        this.amount = null;
      }
    },
    calculateAmount: function (kosteus, nnk) {
      return (
        Math.round(
          (((this.getPhDelta / 0.4) * 20) / (((100 - kosteus) / 100) * nnk)) *
            this.getMaalaji *
            10
        ) / 10
      );
    },
  },
  data: function () {
    return {
      kosteus: null,
      nnk: null,
      amount: null,
      showProduct: false,
      firstClick: true,
    };
  },
};
</script>

<style scoped lang="scss">
.input-narrow {
  width: 200px;
}
.info-text {
  font-size: 11px;
  margin-top: 16px;
  color: var(--bs-dark);
}
.small-title {
  font-size: 1rem;
}
@media screen and (max-width: 768px) {
  .small-title {
    font-size: 0.8rem;
  }
}

span.error-message {
  color: var(--bs-red);
}

.laskuri-container {
  @media screen and (min-width: 768px) {
    padding: 2rem 3rem;
  }

  @media screen and (max-width: 768px) {
    padding: 1rem 1rem;
  }

  background-color: var(--bs-green);

  .laskuri-column {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    .laskuri-input {
      margin-bottom: 1rem;
    }
    .laskuri-submit-input {
      order: 5;
      height: 100%;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          margin-right: 0.6rem;
        }
      }
    }

    .laskuri-area-input {
      @media screen and (max-width: 768px) {
        order: 1;
      }
    }
  }

  .show-button {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    @media screen and (max-width: 768px) {
      justify-content: center;
    }
    button {
      padding: 4px 34px;
      align-self: flex-end;
    }
  }
}

.other-result {
  border-bottom: 1px solid #fff;
  padding-bottom: 1rem;
}

.add-own:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>
